/* AVISTAR PDP: pack-size selector with live per-unit savings, subscription (selling plan) support, slide-out-cart add. */
(function () {
  var root = document.querySelector('[data-av-pdp]');
  if (!root || root.dataset.avInit) return;
  root.dataset.avInit = '1';

  var variants = [];
  var initial = { opts: [] };
  try { variants = JSON.parse(root.querySelector('[data-av-variants]').textContent); } catch (e) {}
  try { initial = JSON.parse(root.querySelector('[data-av-initial]').textContent); } catch (e) {}
  if (!variants.length) return;

  var packsEl = root.querySelector('[data-av-packs]');
  var sizeIdx = packsEl ? (parseInt(packsEl.getAttribute('data-size-index'), 10) - 1) : -1;
  var selected = (initial.opts && initial.opts.length) ? initial.opts.slice() : variants[0].opts.slice();
  var qty = 1;
  var selectedPlan = null; // null = one-time purchase; otherwise a selling_plan id

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function count(v) { var m = String(v || '').match(/(\d[\d,]*)/); return m ? parseInt(m[1].replace(/,/g, ''), 10) || 1 : 1; }
  function same(a, b) { if (a.length !== b.length) return false; for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false; return true; }
  function find(opts) { for (var i = 0; i < variants.length; i++) if (same(variants[i].opts, opts)) return variants[i]; return null; }

  // selling-plan helpers
  function planAlloc(v, planId) {
    if (!v || !v.sp || planId == null) return null;
    for (var i = 0; i < v.sp.length; i++) if (v.sp[i].id === planId) return v.sp[i];
    return null;
  }
  // effective price for a variant given the current purchase option (subscription discount applied when selected)
  function effPrice(v) {
    if (!v) return 0;
    var a = planAlloc(v, selectedPlan);
    return a ? a.price : v.price;
  }

  function ensureValid() {
    var v = find(selected);
    if (v && v.available) return;
    for (var i = 0; i < variants.length; i++) {
      var vv = variants[i]; if (!vv.available) continue;
      var ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (j === sizeIdx) continue;
        if (vv.opts[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) { selected = vv.opts.slice(); return; }
    }
    var first = variants.filter(function (x) { return x.available; })[0] || variants[0];
    selected = first.opts.slice();
  }

  function render() {
    ensureValid();
    var current = find(selected);

    // if a plan is selected but the current variant has no allocation for it, fall back to one-time
    if (selectedPlan != null && !planAlloc(current, selectedPlan)) {
      selectedPlan = null;
      var otRadio = root.querySelector('[data-av-purchase] input[value="onetime"]');
      if (otRadio) otRadio.checked = true;
    }

    // pack cards (per-unit / save% reflect the selected purchase option)
    if (packsEl && sizeIdx >= 0) {
      var pus = [];
      var cards = packsEl.querySelectorAll('[data-av-size]');
      cards.forEach(function (btn) {
        var test = selected.slice(); test[sizeIdx] = btn.getAttribute('data-av-size');
        var v = find(test);
        if (v && v.available) pus.push(effPrice(v) / count(test[sizeIdx]));
      });
      var base = pus.length ? Math.max.apply(null, pus) : 0;
      cards.forEach(function (btn) {
        var size = btn.getAttribute('data-av-size');
        var test = selected.slice(); test[sizeIdx] = size;
        var v = find(test);
        var pu = btn.querySelector('[data-pu]'), sv = btn.querySelector('[data-sv]'), tot = btn.querySelector('[data-total]');
        if (v && v.available) {
          btn.removeAttribute('disabled');
          var price = effPrice(v);
          var unit = price / count(size);
          var save = base > 0 ? Math.round((1 - unit / base) * 100) : 0;
          pu.textContent = money(unit) + ' ea';
          tot.textContent = money(price) + ' total';
          if (save > 0) { sv.textContent = 'Save ' + save + '%'; sv.classList.remove('is-base'); }
          else { sv.textContent = 'Base'; sv.classList.add('is-base'); }
        } else {
          btn.setAttribute('disabled', '');
          pu.textContent = 'Unavailable'; sv.textContent = ' '; tot.textContent = ' ';
        }
        btn.setAttribute('aria-pressed', size === selected[sizeIdx] ? 'true' : 'false');
      });
    }

    // secondary option pills
    root.querySelectorAll('[data-av-opt]').forEach(function (grp) {
      var oi = parseInt(grp.getAttribute('data-av-opt'), 10) - 1;
      grp.querySelectorAll('[data-av-optval]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-av-optval') === selected[oi] ? 'true' : 'false');
      });
    });

    // purchase-option prices (one-time + each plan) for the current variant
    var otEl = root.querySelector('[data-av-price-onetime]');
    if (otEl && current) otEl.textContent = current.available ? money(current.price) : '';
    root.querySelectorAll('[data-av-price-plan]').forEach(function (el) {
      var pid = parseInt(el.getAttribute('data-av-price-plan'), 10);
      var a = planAlloc(current, pid);
      if (a && current && current.available) {
        el.innerHTML = '<span class="av-pdp__pur-was">' + money(current.price) + '</span>' + money(a.price);
      } else {
        el.textContent = '';
      }
    });

    // add button
    var add = root.querySelector('[data-av-add]');
    var label = root.querySelector('[data-av-addlabel]');
    if (current && current.available) {
      add.removeAttribute('disabled');
      var lead = selectedPlan != null ? 'Subscribe · ' : 'Add to cart · ';
      label.textContent = lead + money(effPrice(current) * qty);
    } else {
      add.setAttribute('disabled', '');
      label.textContent = 'Sold out';
    }
    root._variantId = current ? current.id : null;
  }

  // events
  if (packsEl) packsEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-av-size]'); if (!b || b.hasAttribute('disabled')) return;
    selected[sizeIdx] = b.getAttribute('data-av-size'); render();
  });
  root.querySelectorAll('[data-av-opt]').forEach(function (grp) {
    var oi = parseInt(grp.getAttribute('data-av-opt'), 10) - 1;
    grp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-av-optval]'); if (!b) return;
      selected[oi] = b.getAttribute('data-av-optval'); render();
    });
  });
  var purchaseEl = root.querySelector('[data-av-purchase]');
  if (purchaseEl) purchaseEl.addEventListener('change', function (e) {
    var r = e.target.closest('input[name="av-purchase"]'); if (!r) return;
    selectedPlan = r.value === 'plan' ? (parseInt(r.getAttribute('data-av-plan'), 10) || null) : null;
    render();
  });
  var qEl = root.querySelector('[data-av-qty]');
  root.querySelector('[data-av-minus]').addEventListener('click', function () { qty = Math.max(1, qty - 1); qEl.value = qty; render(); });
  root.querySelector('[data-av-plus]').addEventListener('click', function () { qty += 1; qEl.value = qty; render(); });
  qEl.addEventListener('input', function () { var v = parseInt(qEl.value, 10); qty = (isNaN(v) || v < 1) ? 1 : v; render(); });

  // gallery thumbs
  root.querySelectorAll('[data-av-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById('av-main-img'); if (main) main.src = t.getAttribute('data-av-thumb');
      root.querySelectorAll('.av-pdp__thumb').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });

  // add to cart -> slide-out cart drawer
  root.querySelector('[data-av-add]').addEventListener('click', function () {
    var id = root._variantId; if (!id) return;
    var current = find(selected);
    var add = root.querySelector('[data-av-add]');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var item = { id: id, quantity: qty };
    // only attach a selling plan the current variant actually offers
    if (selectedPlan != null && planAlloc(current, selectedPlan)) item.selling_plan = selectedPlan;
    add.setAttribute('disabled', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); }
      else { window.location.href = '/cart'; }
      add.removeAttribute('disabled');
    }).catch(function () { add.removeAttribute('disabled'); window.location.href = '/cart'; });
  });

  render();
})();
